module.exports = __webpack_public_path__ + "static/media/wicket2.9ba16218.png";